<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="150px"
      :model="formLabelAlign"
    >
      <el-form-item label="规则名称">
        <el-input
          v-model="formLabelAlign.name"
          class="in_dwer"
        />
      </el-form-item>
      <el-form-item label="回传开关">
        <el-radio-group v-model="formLabelAlign.is_open">
          <el-radio-button :label="0">关闭</el-radio-button>
          <el-radio-button :label="1">开启</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group
          v-model="type"
          @change="typelist"
        >
          <el-radio-button :label="1">常规</el-radio-button>
          <el-radio-button :label="2">自定义</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="type == 1"
        label="回传充值"
      >
        <el-radio-group v-model="formLabelAlign.report_recharge_type">
          <el-radio-button :label="1">回传用户当天所有充值</el-radio-button>
          <el-radio-button :label="2">回传用户24小时内所有充值</el-radio-button>
          <el-radio-button :label="3">回传用户当天首充</el-radio-button>
          <el-radio-button :label="4">回传用户24小时内首充</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="type == 2"
        label="回传充值"
      >
        <el-radio-group v-model="formLabelAlign.report_recharge_type">
          <el-radio-button
            :label="1"
            style="margin-bottom: 10px;"
          >回传用户当天充值金额大于Y 元的所有充值</el-radio-button>
          <el-radio-button :label="2">回传用户24小时内充值金额大于Y 元的所有充值</el-radio-button>
          <el-radio-button :label="3">回传用户当天充值金额大于Y 元的首充</el-radio-button>
          <el-radio-button :label="4">回传用户24小时内充值金额大于Y 元的首充</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="type == 2"
        label="自定义回传充值金额"
      >
        <el-input-number
          v-model="formLabelAlign.diy_amount"
          :min="1"
          label="自定义回传充值金额"
        />
      </el-form-item>
      <el-form-item label="回传部分订单设置">
        <el-checkbox
          v-model="formLabelAlign.is_open_part"
          :true-label="1"
          :false-label="0"
        >勾选开启<span style="color: red;margin-left: 10px;">提示: 系统按广告计划维度执行[回传部分订单]，每条广告的回传相互独立!</span> </el-checkbox>
      </el-form-item>
      <el-form-item v-if="formLabelAlign.is_open_part == 1">
        <div>
          每条
          <el-select v-model="formLabelAlign.part_led_by" placeholder="请选择">
            <el-option label="广告计划" value="1" />
            <el-option label="广告主" value="2" />
            <el-option label="公众号" value="3" />
          </el-select>
          每日先回传 <el-input-number
            v-model="formLabelAlign.part_pre_num"
            size="mini"
            :min="0"
          /> 笔，再按如下策略进行回传
        </div>
      </el-form-item>
      <el-form-item v-if="formLabelAlign.is_open_part == 1">
        <el-radio-group v-model="formLabelAlign.part_type">
          <el-radio-button
            :label="1"
            style="margin-bottom: 10px;"
          >百分比回传</el-radio-button>
          <el-radio-button :label="2">循环比例回传<el-tooltip
            content="选项左侧值为上报，右侧为不上报，默认5:1，如果选择2:1，就是第1笔不上报，第2，3笔上报，第4笔不上报，第5，6笔上报，如此循环"
            placement="top"
          >
            <i
              class="el-icon-info"
              style="font-size: 15px;margin-left: 10px;"
            />
          </el-tooltip></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formLabelAlign.is_open_part == 1 && formLabelAlign.part_type == 1">
        <el-radio-group v-model="formLabelAlign.part_rate">
          <el-radio :label="10">10%</el-radio>
          <el-radio :label="20">20%</el-radio>
          <el-radio :label="30">30%</el-radio>
          <el-radio :label="40">40%</el-radio>
          <el-radio :label="50">50%</el-radio>
          <el-radio :label="60">60%</el-radio>
          <el-radio :label="70">70%</el-radio>
          <el-radio :label="80">80%</el-radio>
          <el-radio :label="90">90%</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.is_open_part == 1 && formLabelAlign.part_type == 2"
        label="比例选择"
      >
        <el-select
          v-model="copypart_rate"
          placeholder="比例选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.is_open_part == 1 && formLabelAlign.part_type == 2"
        label="循环规则"
      >
        <el-radio-group v-model="formLabelAlign.part_loop_type">
          <el-radio-button
            :label="1"
            style="margin-bottom: 10px;"
          >按订单轮询</el-radio-button>
          <el-radio-button :label="2">每日重置</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="VIP充值金额上报">
        <el-radio-group v-model="formLabelAlign.is_report_vip_amount">
          <el-radio-button :label="0">不上报</el-radio-button>
          <el-radio-button :label="1">上报</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="注册回传比例选择">
        <el-select
          v-model="formLabelAlign.rate"
          placeholder="比例选择"
        >
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="是否默认">
        <el-radio-group v-model="formLabelAlign.is_default">
          <el-radio-button :label="1">否</el-radio-button>
          <el-radio-button :label="2">是</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { backRuleAdmincreate, backRuleAdminupdate } from '@/api/returnPolicyList.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      type: 1,
      formLabelAlign: {
        name: '',
        is_open: 0,
        report_recharge_type: 1,
        diy_amount: 0,
        is_open_part: 0,
        part_pre_num: 1,
        part_type: 1,
        part_rate: 10,
        part_loop_type: 1,
        is_report_vip_amount: 0,
        rate: 10,
        is_default: 1,
        part_led_by: '1'
      },
      copypart_rate: 100,
      options: [
        {
          value: 100,
          label: '1:1'
        },
        {
          value: 34,
          label: '1:3'
        },
        {
          value: 67,
          label: '2:3'
        },
        {
          value: 50,
          label: '1:2'
        },
        {
          value: 150,
          label: '3:2'
        },
        {
          value: 200,
          label: '2:1'
        },
        {
          value: 300,
          label: '3:1'
        },
        {
          value: 400,
          label: '4:1'
        },
        {
          value: 500,
          label: '5:1'
        },
        {
          value: 600,
          label: '6:1'
        },
        {
          value: 700,
          label: '7:1'
        },
        {
          value: 800,
          label: '8:1'
        },
        {
          value: 900,
          label: '9:1'
        }
      ],
      optionsr: [
        {
          value: 10,
          label: '10%'
        },
        {
          value: 20,
          label: '20%'
        },
        {
          value: 30,
          label: '30%'
        },
        {
          value: 40,
          label: '40%'
        },
        {
          value: 50,
          label: '50%'
        },
        {
          value: 60,
          label: '60%'
        },
        {
          value: 70,
          label: '70%'
        },
        {
          value: 80,
          label: '80%'
        },
        {
          value: 90,
          label: '90%'
        }
      ],
      optionsrr: [
        {
          value: 10,
          label: '10%'
        },
        {
          value: 20,
          label: '20%'
        },
        {
          value: 30,
          label: '30%'
        },
        {
          value: 40,
          label: '40%'
        },
        {
          value: 50,
          label: '50%'
        },
        {
          value: 60,
          label: '60%'
        },
        {
          value: 70,
          label: '70%'
        },
        {
          value: 80,
          label: '80%'
        },
        {
          value: 90,
          label: '90%'
        },
        {
          value: 100,
          label: '100%'
        }
      ],
      typer: null,
      id: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(typer, item) {
      this.typer = typer
      // eslint-disable-next-line eqeqeq
      if (this.typer == 1) {
        console.log('新增')
      } else {
        console.log('编辑', item)
        this.id = item.id
        this.formLabelAlign.name = item.name
        this.formLabelAlign.is_open = item.is_open
        this.formLabelAlign.part_led_by = String(item.part_led_by)
        // eslint-disable-next-line eqeqeq
        if (item.diy_amount == 0) {
          this.type = 1
        } else {
          this.type = 2
        }
        this.formLabelAlign.report_recharge_type = item.report_recharge_type
        this.formLabelAlign.diy_amount = item.diy_amount
        this.formLabelAlign.is_open_part = item.is_open_part
        // eslint-disable-next-line eqeqeq
        if (item.is_open_part == 1) {
          this.formLabelAlign.part_pre_num = item.part_pre_num
          this.formLabelAlign.part_type = item.part_type
        }
        // eslint-disable-next-line eqeqeq
        if (item.is_open_part == 1 && item.part_type == 1) {
          this.formLabelAlign.part_rate = item.part_rate
        }
        // eslint-disable-next-line eqeqeq
        if (item.is_open_part == 1 && item.part_type == 2) {
          this.copypart_rate = item.part_rate
          this.formLabelAlign.part_loop_type = item.part_loop_type
        }
        this.formLabelAlign.is_report_vip_amount = item.is_report_vip_amount
        this.formLabelAlign.rate = item.rate
        this.formLabelAlign.is_default = item.is_default
      }
    },
    typelist(value) {
      console.log('value', value)
      // eslint-disable-next-line eqeqeq
      // if (value == 1) {
      //   this.formLabelAlign.diy_amount = 0
      // }
    },
    sumbitr() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.name == '') {
        this.$message({
          message: '请填写规则名称',
          type: 'error'
        })
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.typer == 1) {
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.is_open_part == 0) {
          backRuleAdmincreate({
            name: this.formLabelAlign.name,
            is_open: this.formLabelAlign.is_open,
            report_recharge_type: this.formLabelAlign.report_recharge_type,
            // eslint-disable-next-line eqeqeq
            diy_amount: this.type == 1 ? 0 : this.formLabelAlign.diy_amount,
            is_open_part: this.formLabelAlign.is_open_part,
            is_report_vip_amount: this.formLabelAlign.is_report_vip_amount,
            rate: this.formLabelAlign.rate,
            is_default: this.formLabelAlign.is_default,
            part_led_by: this.formLabelAlign.part_led_by
          }).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.code == 0) {
              this.$emit('updata')
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            }
          })
        } else {
          const obj = {}
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.part_type == 1) {
            console.log('百分比')
            obj.part_rate = this.formLabelAlign.part_rate
          } else {
            obj.part_rate = this.copypart_rate
            obj.part_loop_type = this.formLabelAlign.part_loop_type
            console.log('循环比例回传')
          }
          backRuleAdmincreate({
            name: this.formLabelAlign.name,
            is_open: this.formLabelAlign.is_open,
            report_recharge_type: this.formLabelAlign.report_recharge_type,
            // eslint-disable-next-line eqeqeq
            diy_amount: this.type == 1 ? 0 : this.formLabelAlign.diy_amount,
            is_open_part: this.formLabelAlign.is_open_part,
            part_pre_num: this.formLabelAlign.part_pre_num,
            ...obj,
            is_report_vip_amount: this.formLabelAlign.is_report_vip_amount,
            rate: this.formLabelAlign.rate,
            is_default: this.formLabelAlign.is_default,
            part_type: this.formLabelAlign.part_type,
            part_led_by: this.formLabelAlign.part_led_by
          }).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.code == 0) {
              this.$emit('updata')
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            }
          })
        }
      } else {
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.is_open_part == 0) {
          backRuleAdminupdate({
            id: this.id,
            status: 1,
            name: this.formLabelAlign.name,
            is_open: this.formLabelAlign.is_open,
            report_recharge_type: this.formLabelAlign.report_recharge_type,
            // eslint-disable-next-line eqeqeq
            diy_amount: this.type == 1 ? 0 : this.formLabelAlign.diy_amount,
            is_open_part: this.formLabelAlign.is_open_part,
            is_report_vip_amount: this.formLabelAlign.is_report_vip_amount,
            rate: this.formLabelAlign.rate,
            is_default: this.formLabelAlign.is_default,
            part_led_by: this.formLabelAlign.part_led_by
          }).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.code == 0) {
              this.$emit('updata')
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            }
          })
        } else {
          const obj = {}
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.part_type == 1) {
            console.log('百分比')
            obj.part_rate = this.formLabelAlign.part_rate
          } else {
            obj.part_rate = this.copypart_rate
            obj.part_loop_type = this.formLabelAlign.part_loop_type
            console.log('循环比例回传')
          }
          backRuleAdminupdate({
            id: this.id,
            status: 1,
            name: this.formLabelAlign.name,
            is_open: this.formLabelAlign.is_open,
            report_recharge_type: this.formLabelAlign.report_recharge_type,
            // eslint-disable-next-line eqeqeq
            diy_amount: this.type == 1 ? 0 : this.formLabelAlign.diy_amount,
            is_open_part: this.formLabelAlign.is_open_part,
            part_pre_num: this.formLabelAlign.part_pre_num,
            ...obj,
            is_report_vip_amount: this.formLabelAlign.is_report_vip_amount,
            rate: this.formLabelAlign.rate,
            is_default: this.formLabelAlign.is_default,
            part_type: this.formLabelAlign.part_type,
            part_led_by: this.formLabelAlign.part_led_by
          }).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.code == 0) {
              this.$emit('updata')
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.in_dwer {
  width: 400px;
}
</style>
